<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>
          <a href="javascript: history.back()">Badge Application</a>
          <span>/</span> Add Badge
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="contentBox">
        <div>
          <div class="container">
            <h1>Add Badge</h1>

            <p class="my-3">&nbsp;</p>

            <div v-if="BadgeStatus && !DeadlinePassed">
              <div class="alert alert-light text-dark" role="alert">
                <p>
                  <i class="fas fa-exclamation-circle"> </i> All the information
                  should be filled up in English
                </p>
              </div>
              <p class="my-3">&nbsp;</p>

              <form id="form" @submit.prevent="AddBadge">
                <div v-if="!Exh_Thai">
                  <p class="formTitle">
                    Company Name<span class="red">*</span>
                  </p>
                  <div class="langTip mb-3">
                    <input
                      type="text"
                      required
                      class="maxText textStyle"
                      maxlength="200"
                      v-model="Badge_Company"
                      @input="(e) => filterField('Badge_Company', e)"
                      @compositionstart="isComposing = true"
                      @compositionend="
                        (e) => handleCompositionEnd('Badge_Company', e)
                      "
                    />
                    <span>EN</span>
                  </div>

                  <p class="formTitle">Name <span class="red">*</span></p>
                  <div class="langTip mb-3">
                    <input
                      type="text"
                      class="maxText textStyle"
                      required
                      maxlength="200"
                      v-model="Badge_Name"
                      @input="(e) => filterField('Badge_Name', e)"
                      @compositionstart="isComposing = true"
                      @compositionend="
                        (e) => handleCompositionEnd('Badge_Name', e)
                      "
                    />
                    <span>EN</span>
                  </div>
                </div>

                <div v-else-if="Exh_Thai">
                  <p class="formTitle">
                    Company Name <span class="red">*</span>
                  </p>
                  <div class="langTip mb-3">
                    <input
                      type="text"
                      required
                      name="CompanyTopic"
                      class="maxText textStyle"
                      maxlength="200"
                      :value="Badge_Company"
                      @input="(e) => filterField('Badge_Company', e)"
                      @compositionstart="isComposing = true"
                      @compositionend="
                        (e) => handleCompositionEnd('Badge_Company', e)
                      "
                    />
                    <span>EN</span>
                  </div>

                  <p class="formTitle">FirstName <span class="red">*</span></p>
                  <div class="langTip mb-3">
                    <input
                      type="text"
                      required
                      name="NameTopic"
                      class="maxText textStyle"
                      maxlength="200"
                      :value="Badge_FirstName"
                      @input="(e) => filterField('Badge_FirstName', e)"
                      @compositionstart="isComposing = true"
                      @compositionend="
                        (e) => handleCompositionEnd('Badge_FirstName', e)
                      "
                    />
                    <span>EN</span>
                  </div>

                  <p class="formTitle">LastName <span class="red">*</span></p>
                  <div class="langTip mb-3">
                    <input
                      type="text"
                      required
                      name="NameTopic"
                      class="maxText textStyle"
                      maxlength="200"
                      :value="Badge_LastName"
                      @input="(e) => filterField('Badge_LastName', e)"
                      @compositionstart="isComposing = true"
                      @compositionend="
                        (e) => handleCompositionEnd('Badge_LastName', e)
                      "
                    />
                    <span>EN</span>
                  </div>

                  <p class="formTitle">Job Title <span class="red">*</span></p>
                  <div class="langTip mb-3">
                    <input
                      type="text"
                      required
                      name="NameTopic"
                      class="maxText textStyle"
                      maxlength="200"
                      :value="Badge_JobTitle"
                      @input="(e) => filterField('Badge_JobTitle', e)"
                      @compositionstart="isComposing = true"
                      @compositionend="
                        (e) => handleCompositionEnd('Badge_JobTitle', e)
                      "
                    />
                    <span>EN</span>
                  </div>

                  <p class="formTitle">Email <span class="red">*</span></p>
                  <div class="langTip mb-3">
                    <input
                      type="email"
                      required
                      name="NameTopic"
                      class="maxText textStyle"
                      maxlength="200"
                      :value="Badge_Email"
                      @input="(e) => filterField('Badge_Email', e)"
                      @compositionstart="isComposing = true"
                      @compositionend="
                        (e) => handleCompositionEnd('Badge_Email', e)
                      "
                    />
                    <span>EN</span>
                  </div>
                </div>

                <div class="text-center mt-4">
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg d-inline-block"
                  >
                    Add
                  </button>

                  <button
                    type="button"
                    class="btn btn-secondary btn-lg ml-3 d-inline-block"
                    @click="BackBadgeList"
                  >
                    Back
                  </button>
                </div>
              </form>
            </div>
            <div v-else>
              <p class="mt-4">*Badge Application is currently not open</p>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import Dashboard from "@/components/Dashboard.vue";

export default {
  components: {
    Dashboard,
  },
  metaInfo() {
    return {
      title: `Add Badge - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",
      videoList: [],
      videoID: "",
      videoData: [],

      videoType: 3,
      VideoTopic: "",
      eVideoTopic: "",
      videoLink: "",
      videoLink_Youku: "",
      VideoContent: "",
      videoArchive: "0",
      show: false,
      CSRF_Token: "",
      VideoAmount: 0,
      VideoPub: 0,
      lang: "en",
      date: "",

      UploadvideoID: "",
      Serno: "",

      //判斷各頁狀態儀表版值
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",

      //判斷儀表板是否有線上展
      HasOnlineExpo: "",
      openOnlineExpo: "",
      showOnlineStatus: false,

      isComposing: false,

      ExhCode: "",
      Exh_Thai: false,
      Badge_Name: "",
      Badge_Company: "",
      Badge_JobTitle: "",
      Badge_Email: "",
      Badge_FirstName: "",
      Badge_LastName: "",
      BadgeDeadline: "",
      DeadlinePassed: false,
      BadgeStatus: true,
    };
  },

  watch: {},

  methods: {
    BackBadgeList() {
      const vm = this;
      window.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Badge?no=${vm.RegNo}`;
    },

    filterField(field, e) {
      if (this.isComposing) return;
      const cleaned = e.target.value.replace(
        /[^a-zA-Z0-9 $*^!@#&()+%,./-]/g,
        ""
      );

      this[field] = cleaned;
      e.target.value = cleaned;
    },

    handleCompositionEnd(field, e) {
      this.isComposing = false;
      const cleaned = e.target.value.replace(
        /[^a-zA-Z0-9 $*^!@#&()+%,./-]/g,
        ""
      );
      this[field] = cleaned;
      e.target.value = cleaned;
    },

    AddBadge() {
      const vm = this;

      let url = `https://www.chanchao.com.tw/apiExhibitors/Badge/Add`;
      const fullName = vm.Exh_Thai
        ? `${vm.Badge_FirstName || ""} ${vm.Badge_LastName || ""}`.trim()
        : vm.Badge_Name;

      const info = {
        RegNo: vm.RegNo,
        Badge_FirstName: vm.Badge_FirstName,
        Badge_LastName: vm.Badge_LastName,
        Badge_Name: fullName,
        Badge_Company: vm.Badge_Company,
        Badge_JobTitle: vm.Badge_JobTitle,
        Badge_Email: vm.Badge_Email,
        CSRF: vm.CSRF_Token,
      };

      axios
        .post(url, info)
        .then((response) => {
          if (response.data.Code == 200) {
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Badge?no=${vm.RegNo}`;
          } else if (response.data.Code == 251) {
            alert("Other conditions or sending failed.");
          } else if (response.data.Code == 252) {
            alert("CSRF validation failed");
          } else if (response.data.Code == 253) {
            alert("This email is already registered. Please use another email");
          } else if (response.data.Code == 254) {
            alert("Addition failed");
          } else if (response.data.Code == 255) {
            alert(
              "Format error: Name can only contain letters, numbers, and spaces; please enter a valid email address"
            );
          } else if (response.data.Code == 500) {
            alert("The system is busy. Please try again later.");
          }
        })
        .catch((error) => {
          console.error("Error updating Fascia Name:", error);
        });
    },
  },

  computed: {
    VideoAvailable() {
      const vm = this;
      return vm.VideoAmount - vm.VideoPub;
    },
  },

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.videoID = currentUrl.split("id=")[1];

    //取得時間
    let theDate = new Date();
    vm.date = `${theDate.getFullYear()}/${
      theDate.getMonth() + 1
    }/${theDate.getDate()}`;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Badge/List/${vm.RegNo}`)
      .then((response) => {
        if (response.data.Code == 404) {
          vm.BadgeStatus = false;
        } else {
          vm.BadgeDeadline = response.data.Data.ES_Badge_Deadline;
          let BadgeArchived = response.data.Data.ES_Badge_Archived;

          if (BadgeArchived) {
            vm.BadgeStatus = true;

            //取得時間
            let today = new Date();
            today.setHours(0, 0, 0, 0);

            let deadlineStr = vm.BadgeDeadline.replace(/\//g, "-"); // 轉成安全格式
            let deadline = new Date(deadlineStr);
            deadline.setHours(0, 0, 0, 0);

            if (today > deadline) {
              vm.DeadlinePassed = true;
            } else {
              vm.DeadlinePassed = false;
            }
          } else {
            vm.BadgeStatus = false;
          }
        }
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        let ExhCode = response.data.Data.Original_Code;
        // 泰國展會更換為多欄位版本
        if (ExhCode == "FPCBTH") {
          vm.Exh_Thai = true;
        } else {
          vm.Exh_Thai = false;
        }
      });
  },
};
</script>

<style lang="scss">
.grayBG {
  background: #f0f4f5;
  color: #333;
  padding: 5px 10px;
  display: inline-block;
  word-break: break-all;
  font-size: 14px;
}
</style>
